import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import GearViewer from './GearViewer';
import ThreeDConfigurator from './ThreeDConfigurator';
import EngineeringDrawingViewer from './EngineeringDrawingViewer';
import About from './About';
import HowItWorks from './HowItWorks';
import Navbar from './Navbar';
import ScrollToTop from './ScrollToTop';
import './App.css';

function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/gears" element={<GearViewer />} />
        <Route path="/3d-configurator" element={<ThreeDConfigurator />} />
        <Route path="/engineering-drawing" element={<EngineeringDrawingViewer />} />
      </Routes>
    </>
  );
}

export default App;
